export const MODULE_LIMIT = 25;

export const VALUE = "VALUE";
export const UNIT = "UNIT";
export const KEY = "KEY";

export const GB = "GB";
export const KB = "KB";
export const MB = "MB";
export const B = "B";